module.exports = __webpack_public_path__ + "img/zippo7.fc004319.webp";